import { render } from "./hisBooks.vue?vue&type=template&id=c82a7b44&scoped=true"
import script from "./hisBooks.vue?vue&type=script&lang=js"
export * from "./hisBooks.vue?vue&type=script&lang=js"

import "./hisBooks.vue?vue&type=style&index=0&id=c82a7b44&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82a7b44"]])

export default __exports__